import dynamicLocalization from "@/mixins/dynamic-localization";
import FormField from "../field/index";

export default {
  props: {
    title: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  components: { FormField },
  mixins: [dynamicLocalization],
  methods: {
    onFormFieldUpdate(fieldData) {
      this.$emit("update", fieldData);
    },
  },
};
